export class StockEntryLocationLine {
  stockEntryId: number;
  stockLocationId: number;

  constructor(values: any = {}) {
    this.stockEntryId = values.stockEntryId;
    this.stockLocationId = values.stockLocationId;
  }
}
